import { render, staticRenderFns } from "./full-lessons.vue?vue&type=template&id=e89c23de&"
import script from "./full-lessons.vue?vue&type=script&lang=js&"
export * from "./full-lessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports